'use client';

import { c as _c } from "react/compiler-runtime";
import CalendarIcon from '@eversports/design-tokens/assets/icons/regular/calendar.svg?icon';
import { cn } from '@eversports/klimt-design-components/tailwind/utils';
import Button from '@eversports/klimt-primitives/Button';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { Calendar } from '../../../../../../../../../components/Calendar';
import { Popover, PopoverContent, PopoverTrigger } from '../../../../../../../../../components/Popover';
interface Props {
  selectedDate?: Date;
  formattedDate?: string;
  updateFilter: (value: Date | undefined) => void;
}
const DateFilterDropdown = t0 => {
  const $ = _c(28);
  const {
    selectedDate,
    formattedDate,
    updateFilter
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const t = useTranslations("discover-sport-city");
  let t1;
  if ($[0] !== isOpen) {
    t1 = () => setIsOpen(!isOpen);
    $[0] = isOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const toggleCalendar = t1;
  let t2;
  if ($[2] !== toggleCalendar || $[3] !== updateFilter) {
    t2 = dateSelection => {
      updateFilter(dateSelection);
      toggleCalendar();
    };
    $[2] = toggleCalendar;
    $[3] = updateFilter;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleSelect = t2;
  const t3 = formattedDate ? "tertiary-selected" : "tertiary";
  const t4 = formattedDate ? "text-text-brand-primary" : "text-text-secondary";
  let t5;
  if ($[5] !== t4) {
    t5 = cn("size-2", t4);
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <CalendarIcon className={t5} aria-hidden={true} />;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== formattedDate || $[10] !== t) {
    t7 = formattedDate ?? t("start-date");
    $[9] = formattedDate;
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t3 || $[13] !== t6 || $[14] !== t7) {
    t8 = <PopoverTrigger asChild={true} className="hidden items-center gap-1 sm:flex"><Button size="sm" variant={t3} className="capitalize">{t6}{t7}</Button></PopoverTrigger>;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== selectedDate) {
    t9 = selectedDate ?? new Date();
    $[16] = selectedDate;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = new Date();
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== handleSelect || $[20] !== selectedDate || $[21] !== t9) {
    t11 = <PopoverContent className="w-auto p-0"><Calendar mode="single" selected={selectedDate} onSelect={handleSelect} weekStartsOn={1} defaultMonth={t9} fromDate={t10} /></PopoverContent>;
    $[19] = handleSelect;
    $[20] = selectedDate;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== isOpen || $[24] !== t11 || $[25] !== t8 || $[26] !== toggleCalendar) {
    t12 = <Popover open={isOpen} onOpenChange={toggleCalendar}>{t8}{t11}</Popover>;
    $[23] = isOpen;
    $[24] = t11;
    $[25] = t8;
    $[26] = toggleCalendar;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
};
export default DateFilterDropdown;